import { Lock, MessageCircle, RefreshCw, Zap } from 'lucide-react';
import { TRUST_POINTS } from '@/lib/cro';

const icons = [Zap, Lock, RefreshCw, MessageCircle];

type Props = {
  compact?: boolean;
  className?: string;
};

export function TrustBar({ compact = false, className = '' }: Props) {
  return (
    <ul
      className={`grid gap-3 ${compact ? 'sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-4'} ${className}`}
    >
      {TRUST_POINTS.map((item, i) => {
        const Icon = icons[i] ?? Zap;
        return (
          <li key={item.title} className="flex items-start gap-2.5 text-sm">
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-accent)]" aria-hidden />
            <div>
              <p className="font-medium text-fg">{item.title}</p>
              {!compact && <p className="text-muted">{item.detail}</p>}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
